import { useEffect, useRef } from "hono/jsx";
import { ElectionMapOptions } from "../client/scripts/map.ts";

interface LeafletMapIslandProps {
  options: ElectionMapOptions;
}

export function LeafletMapIsland({ options }: LeafletMapIslandProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const controlRef = useRef<any>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Load the script if not already loaded (though it should be by the parent view)
    // Here we assume window.initElectionMap is available or will be

    // Simple polling for the global function
    const init = () => {
      if (globalThis.window && (globalThis.window as any).initElectionMap) {
        controlRef.current = (globalThis.window as any).initElectionMap(
          containerRef.current,
          options,
        );
        return true;
      }
      return false;
    };

    if (!init()) {
      const interval = setInterval(() => {
        if (init()) clearInterval(interval);
      }, 100);
      return () => clearInterval(interval);
    }

    return () => {
      if (controlRef.current) {
        controlRef.current.destroy();
      }
    };
  }, []);

  // Update data when options change
  useEffect(() => {
    if (controlRef.current && options.initialData) {
      controlRef.current.updateData(options.initialData);
    }
  }, [options.initialData]);

  // Update layer when layerId changes
  useEffect(() => {
    if (controlRef.current && options.layerId) {
      controlRef.current.updateLayer(options.layerId);
    }
  }, [options.layerId]);

  return <div ref={containerRef} class="w-full h-full min-h-[500px] z-0" />;
}
